"use strict";

exports.__esModule = true;
exports.PriorityQueue = void 0;

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } it = o[Symbol.iterator](); return it.next.bind(it); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var PriorityQueue = function () {
  function PriorityQueue(priorities) {
    this.taskMap = {};
    this.running = false;
    this.priorities = priorities;
    this.initTasks(priorities);
  }

  var _proto = PriorityQueue.prototype;

  _proto.getTaskInfo = function getTaskInfo(key) {
    return this.priorities.find(function (item) {
      return item.key === key;
    }) ? this.taskMap[key] : null;
  };

  _proto.execute = function execute(key, payload) {
    var taskInfo = this.taskMap[key];

    if (!taskInfo) {
      return Promise.reject('invalid task name =' + key);
    }

    taskInfo.payload = payload;
    var promise = new Promise(function (resolve, reject) {
      taskInfo.callbacks.push(function (success, msg) {
        return success ? resolve() : reject(msg);
      });
      taskInfo.runLevel++;
    });

    if (!this.running) {
      this.runTask(key);
    }

    return promise;
  };

  _proto.executeAsync = function executeAsync(key, payload) {
    var taskInfo = this.taskMap[key];

    if (!taskInfo) {
      throw new Error('invalid task name =' + key);
    }

    taskInfo.payload = payload;
    taskInfo.runLevel++;

    if (!this.running) {
      this.runTask(key);
    }
  };

  _proto.initTasks = function initTasks(priorities) {
    var _this = this;

    priorities.forEach(function (item) {
      _this.taskMap[item.key] = _extends({}, item, {
        payload: null,
        callbacks: [],
        runLevel: 0
      });
    });
  };

  _proto.runTask = function runTask(key) {
    var _this2 = this;

    var taskInfo = this.taskMap[key];
    var callbacks = taskInfo.callbacks;
    var level = taskInfo.runLevel;
    taskInfo.callbacks = [];
    this.running = true;
    taskInfo.fn(this, taskInfo.payload, level).then(function () {
      if (level === taskInfo.runLevel) {
        callbacks.forEach(function (item) {
          return item(true, '');
        });
      }
    }, function (msg) {
      if (level === taskInfo.runLevel) {
        callbacks.forEach(function (item) {
          return item(false, msg);
        });
      }
    }).then(function () {
      _this2.running = false;

      _this2.detectNextTask();
    }).catch(function (e) {
      console.log(e);
    });
  };

  _proto.detectNextTask = function detectNextTask() {
    for (var _iterator = _createForOfIteratorHelperLoose(this.priorities), _step; !(_step = _iterator()).done;) {
      var priority = _step.value;
      var taskInfo = this.taskMap[priority.key];

      if (taskInfo.callbacks.length) {
        this.runTask(priority.key);
        break;
      }
    }
  };

  return PriorityQueue;
}();

exports.PriorityQueue = PriorityQueue;